export const categoriesBC = [
	{
		id: '1',
		name: 'Cuentas',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '2',
		name: 'Depósitos',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '3',
		name: 'Inversión',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '4',
		name: 'Paquetes',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '5',
		name: 'Tarjetas',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '6',
		name: 'Financiación',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '7',
		name: 'A contratar',
		companyId: 'BC',
		active: false,
		mandatory: false,
	},
	{
		id: '8',
		name: 'Seguros',
		companyId: 'BC',
		active: true,
		mandatory: false,
	},
	{
		id: '9',
		name: 'Planes de Pensiones',
		companyId: 'BC',
		active: false,
		mandatory: false,
	},
	{
		id: '10',
		name: 'Beneficios FarmaSmart de Terceros',
		companyId: 'BC',
		mandatory: false,
	},

	{
		id: '11',
		name: 'Cuenta Inversora',
		companyId: 'BC',
		natureType: 'F',
		mandatory: false,
	},
	{
		id: '12',
		name: 'Avales',
		companyId: 'BC',
		natureType: 'J',
		mandatory: false,
	},
	{
		id: '13',
		name: 'Financiación de Circulante',
		companyId: 'BC',
		natureType: 'J',
		mandatory: false,
	},
	{
		id: '14',
		name: 'Financiación a Largo Plazo',
		companyId: 'BC',
		mandatory: false,
	},
	{
		id: '15',
		name: 'Cobros y pagos',
		companyId: 'BC',
		mandatory: false,
	},
	{
		id: '16',
		name: 'Fondos de Inversión',
		companyId: 'BC',
		mandatory: false,
	},
];
export const categoriesFA = [
	{
		id: '1',
		name: 'Seguros',
		companyId: 'FA',
		mandatory: false,
	},

	{
		id: '2',
		name: 'Depósitos CBNK Banco de colectivos',
		companyId: 'FA',
		mandatory: false,
	},
	{
		id: '3',
		name: 'Cuentas CBNK Banco de colectivos',
		companyId: 'FA',
		mandatory: false,
	},
];
